import { createFileRoute } from '@tanstack/react-router';

import { ClubWorkRequestInfoPage } from '@/features/work/pages/club-work-request-info-page/ClubWorkRequestInfoPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute(
  '/clubOwner/$id/work-request/$workRequestId'
)({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ClubWorkRequestInfoPage
});
